export const getInitials = (name: string) =>
  name
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export const formatStatusLabel = (status: string) => {
  if (status === "complete") return "Complete";
  if (status === "in_progress") return "In Progress";
  if (status === "not_started") return "Not Started";
  return status;
};

export const formatSentimentLabel = (sentiment: string) =>
  sentiment.length > 0 ? sentiment.charAt(0).toUpperCase() + sentiment.slice(1) : "Neutral";

export const formatObjectiveTime = (seconds: number) => {
  if (seconds >= 60) return `${Math.round(seconds / 60)} min`;
  return `${seconds}s`;
};

export const formatTime = (seconds: number) => {
  if (seconds >= 60) return `${Math.round(seconds / 60)}m`;
  return `${seconds}s`;
};

export const mergeObjectiveStatus = (left: string | null | undefined, right: string | null | undefined) => {
  if (left == null) return right;
  if (right == null) return left;
  if (left === "completed" && right === "completed") return "completed";
  if (left === "not_started" && right === "not_started") return "not_started";
  return "in_progress";
};

export type ObjectiveSampleDetail = {
  summary: string;
  successPoints: string[];
  confusionPoints: string[];
};

export const buildOverviewSampleDetail = (
  objectiveLabel: string,
  backendData?: {
    summaries?: string[];
    success_points_details?: string[];
    confusion_points_details?: string[];
    further_recommendations?: string[];
  }
): ObjectiveSampleDetail => {
  const summary = backendData?.summaries?.[0] ?? "No summary available for this objective.";
  const successPoints =
    backendData?.success_points_details && backendData.success_points_details.length > 0
      ? backendData.success_points_details
      : ["No Data Available"];

  const confusionPoints =
    backendData?.confusion_points_details && backendData.confusion_points_details.length > 0
      ? backendData.confusion_points_details
      : ["No Data Available"];

  return {
    summary,
    successPoints,
    confusionPoints,
  };
};
